export const CANDIDATE_LIST = "candidate_list"
export const CANDIDATE_LIST_SUCCESSFUL = "candidate_list_successfull"
export const CANDIDATE_LIST_FAILED = "candidate_list_failed"
// search candidate list
export const CANDIDATE_SEARCH_SUCCESSFUL = "candidate_list_successfull"
export const CANDIDATE_SEARCH_FAILED = "candidate_list_failed"
export const CANDIDATE_SEARCH = "candidate_search_list"
//Delete Candidate
export const CANDIDATE_DELETE = "candidate_delete"
export const CANDIDATE_DELETE_SUCCESSFUL = "candidate_delete_successfull"
export const CANDIDATE_DELETE_FAILED = "candidate_delete_failed"



//CANDIDATE SEARCH LIST

export const CANDIDATE_SEARCHLIST="CANDIDATE_SEARCHLIST"
export const CANDIDATE_SEARCHLIST_SUCCESS="CANDIDATE_SEARCHLIST_SUCCESS"
export const CANDIDATE_SEARCHLIST_ERROR="CANDIDATE_SEARCHLIST_ERROR"

export const GET_SEARCH_CANDIDATE_DATA="GET_SEARCH_CANDIDATE_DATA"
export const GET_SEARCH_DATA="GET_SEARCH_DATA"
export const GET_MAPPED_CANDIDATE_DATA="GET_MAPPED_CANDIDATE_DATA"
export const GET_SEARCH_MAPPED_CANDIDATE_DATA="GET_SEARCH_MAPPED_CANDIDATE_DATA"
export const GET_SEARCH_FILTER_CANDIDATE_DATA="GET_SEARCH_FILTER_CANDIDATE_DATA"
export const GET_TABLE_SEARCH_FILTER = "GET_TABLE_SEARCH_FILTER"
export const GET_SEARCH_SUGGESTION_DATA="GET_SEARCH_SUGGESTION_DATA"
export const GET_SEARCH_TABLE_SUGGESTION_DATA = "GET_SEARCH_TABLE_SUGGESTION_DATA"
export const GET_SEARCH_SUGGESTION_DATA_ERROR="GET_SEARCH_SUGGESTION_DATA_ERROR"
export const GET_SEARCH_SUGGESTION_DATA_SUCCESS="GET_SEARCH_SUGGESTION_DATA_SUCCESS"

